// extracted by mini-css-extract-plugin
module.exports = {"container":"NewestSection_container__vuQ6X","grid":"NewestSection_grid__BIYG9"};